<template>
  <el-drawer
    title="Editar Contacto"
    :append-to-body="true"
    :before-close="handleClose"
    size="30%"
    :visible.sync="innerDrawer"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      style="margin-top: 80px"
    >
      <el-form-item label="Primer nombre" prop="FirstName">
        <el-input
          v-model="ContactData.FirstName"
          :style="{ width: '300px' }"
        ></el-input>
      </el-form-item>

      <el-form-item label="Segundo nombre">
        <el-input
          v-model="ContactData.MiddleName"
          :style="{ width: '300px' }"
        ></el-input>
      </el-form-item>

      <el-form-item label="Apellidos" prop="SurName">
        <el-input
          v-model="ContactData.SurName"
          :style="{ width: '300px' }"
        ></el-input>
      </el-form-item>

      <el-form-item label="Puesto" prop="JobTitle">
        <el-input
          v-model="ContactData.JobTitle"
          :style="{ width: '300px' }"
        ></el-input>
      </el-form-item>

      <el-form-item label="Número de teléfono" prop="PhoneNumber">
        <el-col :span="11">
          <el-input
            v-model="ContactData.PhoneNumber"
            placeholder="Teléfono"
          ></el-input>
        </el-col>
        <el-col :span="11">
          <el-input
            v-model="ContactData.ExtensionNumber"
            placeholder="Extensión"
            :style="{ width: '80px' }"
          ></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="Número de celular">
        <el-input
          v-model="ContactData.MobilePhoneNumber"
          :style="{ width: '300px' }"
        ></el-input>
      </el-form-item>

      <el-form-item label="Correo" prop="Email">
        <el-input
          v-model="ContactData.Email"
          :style="{ width: '300px' }"
        ></el-input>
      </el-form-item>
      <el-row type="flex" justify="end" :gutter="0">
        <el-button-group style="padding: 30px 30px 0 0">
          <el-button type="primary" @click="onSubmit">Gurardar</el-button>
        </el-button-group>
      </el-row>
    </el-form>
  </el-drawer>
</template>
<script>
export default {
  model: {
    prop: "EditContact",
    event: "change"
  },
  // name: "EditContact",
  props: {
    innerDrawer: {
      trype: Boolean,
      default: false
    },
    ContactData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      outerVisible: false,
      innerVisible: false
    };
  },
  methods: {
    handleResponse(resp) {
      if (resp.data) {
        this.$emit("closeDrawer");
        this.drawerLoading = false;
        this.loading = false;
        this.requestLoading = false;
        this.innerDrawer = false;

        this.$emit("update-data", this.model);
        this.$message({
          type: "success",
          message: "Prospecto actualizado exitosamente"
        });
      } else {
        this.$message({
          type: "error",
          message: "Hubo un error al actualizar el prospecto"
        });
      }
    },
    onSubmit() {
      this.requestLoading = true;
      this.$http
        .post(`/api/prospects/edit?`, this.ContactData, {
          timeout: 3 * 60 * 1000,
          params: {
            ContactCode: this.ContactData.ContactCode,
            SalesPersonCode: this.ContactData.PersonCode,
            id: this.ContactData.Id
          }
        })
        .then(this.handleResponse)
        .catch(() => {
          this.requestLoading = false;
          //console.error(x)
        });
    },
    handleClose() {
      this.innerDrawer = false;
    }
  }
};
</script>
